module.exports = __webpack_public_path__ + "81fcebb96a5cca29bf587cf968e3f148.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Penguins1.jpg
// module id = 3290
// module chunks = 0